/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { DescriptionBody } from '../../../../../../../common/ui/description-body';
import { processExcerpt } from '../../../../../../../common/utils/search-result-utils';

import { BaseVideoSearchResult } from './shared/base-video-search-result';
import { type VideoResultRendererProps } from './shared/types';

/**
 * Renderer for MS Teams meeting transcript search results.
 * Does not show video-specific features like thumbnail, duration, or chapters.
 */
export const MeetingTranscriptRenderer = (props: VideoResultRendererProps) => {
	const { data } = props;
	const { excerpt } = data;

	const body = <DescriptionBody description={processExcerpt(excerpt, true)} />;

	return (
		<BaseVideoSearchResult
			{...props}
			body={body}
		/>
	);
};
